import { render, staticRenderFns } from "./ProjectGroupManager.vue?vue&type=template&id=4772dbae"
import script from "./ProjectGroupManager.vue?vue&type=script&lang=js"
export * from "./ProjectGroupManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports